import { render, staticRenderFns } from "./VErrorModal.vue?vue&type=template&id=5284bf64"
import script from "./VErrorModal.vue?vue&type=script&lang=js"
export * from "./VErrorModal.vue?vue&type=script&lang=js"
import style0 from "./VErrorModal.vue?vue&type=style&index=0&id=5284bf64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports